"use client";

import { createContext } from "react";

import type { ChatConversation, ChatHistoryOverview } from "../types";

export type ChatHistoryContextState = {
  fetchConversationHistory: (
    page: number,
    limit: number,
  ) => Promise<{
    data: ChatHistoryOverview;
    total: number;
    page: number;
  }>;
  fetchConversation: (id: string) => Promise<ChatConversation | null>;
  activeConversationID: string | null;
};

export const ChatHistoryContext = createContext<
  ChatHistoryContextState | undefined
>(undefined);
